import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import axiosInstance from 'src/store/components/axiosInstance'

// ** Fetch Designations
export const fetchDesignations = createAsyncThunk('get/designations', async (params, { rejectWithValue }) => {
  try {
    params.table_name = 'designations'
    const response = await axiosInstance.get('form-components', { params: params })
    return response.data.data
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const { message, errors } = error.response.data
      const errorObj = { message, errors }
      return rejectWithValue(errorObj)
    } else {
      if (error.response && error.response.status === 403) {
        return rejectWithValue(error.response.status)
      }
      return rejectWithValue(error.message || 'An error occurred')
    }
  }
})
const saveToRedux = (state, payload) => {
  if (state.data === payload?.data) return

  if (payload?.data) {
    console.log(payload.data.length)
    state.data = payload.data
    state.total = payload.total
    state.nextPageUrl = payload.next_page_url
    state.prevPageUrl = payload.prev_page_url
  } else {
    state.message = payload
  }
}

export const designationSlice = createSlice({
  name: 'designations',
  initialState: {
    data: [], // Array to store designations
    message: '', // Message from API response
    nextPageUrl: null,
    prevPageUrl: null,
    total: 0,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    // API fetching state
    builder.addCase(fetchDesignations.pending, state => {
      state.loading = true // Set loading true to show loading screen
    })

    // API response received state (SUCCESS)
    builder.addCase(fetchDesignations.fulfilled, (state, action) => {
      // Assuming action.payload is the response from the API
      saveToRedux(state, action.payload) // Saving designations to redux
      state.loading = false // Set loading false to hide loading screen
    })

    // API response received state (FAILURE)
    builder.addCase(fetchDesignations.rejected, (state, action) => {
      state.message = action.payload?.message || 'Failed to fetch data!'
      state.loading = false // Set loading false to hide loading screen
    })
  }
})

export default designationSlice.reducer
